import { render } from "./CastrStreamRow.vue?vue&type=template&id=317fac9a"
import script from "./CastrStreamRow.vue?vue&type=script&setup=true&lang=js"
export * from "./CastrStreamRow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformList/CastrStreamRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "317fac9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('317fac9a', __exports__)) {
    api.reload('317fac9a', __exports__)
  }
  
  module.hot.accept("./CastrStreamRow.vue?vue&type=template&id=317fac9a", () => {
    api.rerender('317fac9a', render)
  })

}


export default __exports__